import { render, staticRenderFns } from "./event-card.vue?vue&type=template&id=0bdc9dde&scoped=true"
import script from "./event-card.vue?vue&type=script&lang=js"
export * from "./event-card.vue?vue&type=script&lang=js"
import style0 from "./event-card.vue?vue&type=style&index=0&id=0bdc9dde&prod&scoped=true&lang=css"
import style1 from "./event-card.vue?vue&type=style&index=1&id=0bdc9dde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdc9dde",
  null
  
)

export default component.exports